import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { FaAngleLeft } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { getPartnerDetails } from "../../../../redux/actions/campaignActions";
import ImgChangeIcon from "../../../../assets/images/camera-icon.png";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import "../../../new/new.scss";

const Viewpartner = () => {
  let token = localStorage.getItem("accessToken");
  const id = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const partnerView = useSelector((state) => state.partnerView);
  const { partner } = partnerView;

  useEffect(() => {
    dispatch(getPartnerDetails(token, id));
  }, [dispatch]);

  useEffect(() => {
    if (partnerView) {
      if (partnerView?.loading !== undefined) {
        setLoading(partnerView?.loading);
      }
    }
  }, [partnerView]);

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API + "get-country")
      .then((res) => setData(res.data.data))
      .catch((err) => console.log(err));
  }, []);

  const countries = [...new Set(data)];
  countries.sort();

  return (
    <div className="new">
      <Loader isLoading={loading} />
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <span className="backarrow">
            <FaAngleLeft onClick={() => navigate(-1)} />
          </span>
          <h1 className="view-page-tittle">View Partner</h1>
        </div>

        <div className="bottom">
          <div className="left">
            <div className="profile-pic-div">
              <img
                src={partner?.data?.profile_pic}
                alt=""
                className="setting-profile"
              />
            </div>
          </div>
          <div className="right">
            <form>
              <div className="formInput">
                <label>Title</label>
                <input
                  type="text"
                  name="title"
                  disabled={true}
                  value={partner?.data?.title}
                  placeholder="Enter Title"
                />
              </div>
              <div className="formInput">
                <select
                  name="countryPartner"
                  disabled
                  className="sort-by dropdown"
                  // onChange={(e) => handleCountry(e)}
                  value={partner?.data?.country_id}
                >
                  <option value="11" disabled selected hidden>
                    Italy
                  </option>
                  {countries.map((items) => (
                    <option key={items.id} value={items.id}>
                      {items.country_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="formInput">
                <label>About Partner</label>
                <input
                  type="text"
                  name="description"
                  disabled={true}
                  value={partner?.data?.about_partners}
                  placeholder="Enter Description"
                />
              </div>

              <div className="formInput">
                <label>Description</label>

                <textarea
                  type="text"
                  disabled={true}
                  value={partner?.data?.description}
                  name="description"
                  className="description-textarea"
                  cols="47"
                  rows="5"
                  placeholder="Enter Bio"
                ></textarea>
              </div>
              <div className="formInput"></div>

              {/* <button type="submit" disabled={true} className="submitBtn">
                Save
              </button> */}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Viewpartner;
